import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, parseAsString, parseAsStringLiteral, useQueryStates } from 'nuqs';

export function useRoleListSearchParams() {
  const [{ page, pageSize, search, sort }, setRoleListSearchParams] = useQueryStates({
    search: parseAsString.withDefault(''),
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
    sort: parseAsStringLiteral(dataGridSortDirection).withDefault('asc'),
  });

  const changePageNumber = (pageInput: number) => {
    setRoleListSearchParams({
      page: pageInput,
      pageSize,
      search,
      sort,
    });
  };

  const changePageSize = (pageSizeInput: number) => {
    setRoleListSearchParams({
      page: 0,
      pageSize: pageSizeInput,
      search,
      sort,
    });
  };

  const changeSearch = (searchInput: string) => {
    setRoleListSearchParams({
      page: 0,
      pageSize,
      search: searchInput,
      sort,
    });
  };

  const changeSortDirection = (sortDirection: (typeof dataGridSortDirection)[number]) => {
    setRoleListSearchParams({
      page,
      pageSize,
      search,
      sort: sortDirection,
    });
  };

  return [
    {
      page,
      pageSize,
      search,
      sort,
    },
    {
      changePageNumber,
      changePageSize,
      changeSearch,
      changeSortDirection,
    },
  ] as const;
}
